import React from "react";
import { Container } from 'react-bootstrap';

const Section = ({ children, className, name, heading, subhead, id }) => {

  const classNames = [];

  if(name) classNames.push("section__" + name);

  //if(bg) classNames.push("section__bg-" + bg);

  if(className) classNames.push(className);

  return (
    <>
      <section className={ classNames.join(' ') } id={ id || name }>
        <Container>

          { 
            !!heading &&
            
            <div className="section__header">
              {
                !!subhead &&
                <div className="section__subhead">
                  {subhead}
                </div>
              }
              
              <h2>{heading}</h2>
            </div>
          }
          
          { children }
        </Container>
      </section>

    </>
  )

}

export default Section;
